<template>
  <WorkTabsFormDialog
    ref="addEditDeviceDialog"
    v-model="currentTab"
    :tabs="tabs"
    height="xl"
    width="xl"
    :promise-based-api-request-handler-method="handleApiRequest"
    path-of-form-data-element=""
    :no-simple-close="isNew"
  >
    <template
      v-if="isNew"
      #dialog-actions="{ triggerReject, triggerResolve }"
    >
      <w-btn
        outlined
        @click="triggerReject"
      >
        {{
          $t('Dialogs.BasicDialog.abort')
        }}
      </w-btn>
      <w-btn @click="triggerResolve">
        {{ $t('Common.save') }}
      </w-btn>
    </template>
    <template
      v-else
      #accept-action-text
    >
      {{ $t('Common.accept') }}
    </template>
  </WorkTabsFormDialog>
</template>

<script>
//components
import WorkTabsFormDialog from '@/components/base_components/dialog/form_dialogs/WorkTabsFormDialog';
//mixins
import dataMixin from '@/mixins/data-mixin';
//utils & helpers
import formUtils from '@/utils/form-utils';
import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuid } from 'uuid';
import deviceService from '@/services/device-service';

const DATA_PATH = 'transientData.deviceCopyInEdit';

export default {
  name: 'AddEditDeviceDialog',
  components: {
    WorkTabsFormDialog,
  },
  data() {
    return {
      currentTab: 0,
      deviceId: null,
    };
  },
  mixins: [dataMixin('deviceCopyInEdit', DATA_PATH)],
  computed: {
    isSavedDeviceCopy() {
      return this.deviceCopyInEdit?.derivedFrom != undefined;
    },
    isSavedDevice() {
      return (
        this.deviceId != undefined && !formUtils.isNewFormId(this.deviceId)
      );
    },
    isNew() {
      return !this.isSavedDeviceCopy && !this.isSavedDevice;
    },
    tabs() {
      return [
        {
          text: this.$t('Common.baseData'),
          show: true,
          component: () =>
            import(
              '../../../../modules/devices/components/DeviceBaseData/DevicesFormBaseData'
            ),
          id: '#TabDeviceBaseForm',
          props: {
            dataPath: DATA_PATH,
            overrideGenerateSerialNumber: this.generateSerialNumber,
          },
        },
      ];
    },
  },
  methods: {
    open(deviceId = undefined) {
      this.deviceId = cloneDeep(deviceId);
      return this.$refs.addEditDeviceDialog.open();
    },
    async generateSerialNumber() {
      try {
        const device = {
          data: this.deviceCopyInEdit,
          uuid: uuid().toString(),
        };
        let response = {};
        if (this.isNew) {
          response = await deviceService.post(device);
          this.deviceCopyInEdit = await this.loadDeviceData(response.data);
          this.deviceCopyInEdit.derivedFrom = { id: response.data };
          this.deviceId = response.data;
        } else {
          response = await deviceService.put(this.deviceId, device);
          this.deviceCopyInEdit = await this.loadDeviceData(this.deviceId);
        }
      } catch (error) {
        this.$refs.addEditDeviceDialog.handleError(error);
      }
    },
    async loadDeviceData(id) {
      try {
        const response = await deviceService.loadData(id);
        return response.data.data;
      } catch (error) {
        throw error;
      }
    },
    async handleApiRequest() {
      return new Promise(async (resolve) => {
        if (this.isSavedDeviceCopy)
          resolve(this.deviceId);
        else {
          try {
            await this.generateSerialNumber();
            resolve(this.deviceId)
          } catch (error) {
            this.$refs.addEditDeviceDialog.handleError(error);
          }
        }
      });
    },
  },
};
</script>
